<template>
   <div>
    <div class="topBar-holder">
          <div class="topBar-container">
            <div class="topBar-left">
              <div id="btnSideBar" href="javascript:void(0); " class="">
                <i class="fa-solid fa-bars"></i>
              </div>
              <a href="/">
                <img class="img-responsive logo"
                  src="/static/img/landing/logo-2.png"
                  alt="logo">
              </a>
            </div>
            <div class="topBar-middle d-dev"></div>
            <div class="topBar-right">
              <div class="topbar-buttons d-dev">
                <div class="menuItem">
                  <div class="topbar-right-user-button">
                    <div class="topbarButtons-holder">
                      <div id="btnLoginTop" class="button button-login" data-toggle="modal"
                data-target="#login" href="javascript:void(0); ">ลงชื่อเข้าใช้</div>
                      <div data-toggle="modal" 
                data-target="#regModal"  id="btnRegister" class="button button-signup" href="javascript:void(0);">ลงทะเบียน</div>
                    </div>
                  </div>
                   
                </div>
              </div>
              <div class="m-dev">
                <div class="topbarButtons-holder">
                  <div  class="button button-login" data-toggle="modal"
                data-target="#login" data-type="login">ลงชื่อเข้าใช้</div>
                  <div data-toggle="modal" 
                data-target="#regModal" class="button button-signup" data-type="reg">ลงทะเบียน</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="dashboard-topBar-holder normal hide">
          <div id="btnBack">
            <i class="fa-solid fa-chevron-left"></i>
          </div>
          <div class="dashboard-topBar-title">
            <span class="dashboard-title"></span>
          </div>
        </div>

        <div class="user-loginReg-holder m-dev hide">
          <div class="section-setting">
            <div class="setting-panel">
            </div>
          </div>
        </div>

        <div class="buttonToTop"><i class="fa fa-arrow-up"></i></div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";

export default {
  name: "Header",
  data() {
    return {
      isShowNav: true,
      toggle: true,
      nowPage: this.$route.name,
    };
  },
  watch: {
    $route() {
      this.isShowNav = true;
      this.nowPage = this.$route.name;
      if (
        this.$route.name == "Login" ||
        this.$route.name == "Signup" ||
        this.$route.name == "Profile" ||
        this.$route.name == "Join"
      ) {
        return (this.isShowNav = false);
      }
    },
  },
  mixins: [UserInfoMixins],
  methods: {
    ...mapActions(["userSignOut", "appTitle"]),
    gotoRouteGame(route) {
      this.$router.push({ path: route }).catch(() => {});
    },
    gotoRouteMobile(route) {
      var myCollapse = document.getElementById("navbarSupportedContent");
      console.log(myCollapse.classList.contains("show"));
      if (myCollapse.classList.contains("show")) {
        var bsCollapse = new bootstrap.Collapse(myCollapse);
        bsCollapse.hide();
      }
      this.$router.push(route).catch(() => {});
    },
    gotoRoute(route) {
      this.$router.push(route).catch(() => {});
    },
    getPageActive(page) {
      if (this.nowPage == page) {
        return "menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-9";
      }
    },
    async SignOut() {
      await this.userSignOut();
    },
  },
  computed: {
    ...mapGetters(["getLineId"]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layout/Header.vue